import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

// Shadcn
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Format numbers with thousand separators
export function formatNumber(num: number): string {
  if (num === undefined || num === null) return '0';

  // Handle special cases
  if (num <= 0 || !isFinite(num)) return '0';

  // Convert to string and add thousand separators
  return num.toLocaleString('en-US', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  });
}

// Initials for an avatar: first + last initial, or the first two letters of a single-word name.
export function initialsFromName(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

// Trigger a browser-managed download from a signed URL without buffering the file in app memory.
export async function downloadFile(fileUrl: string, fileName: string): Promise<void> {
  const a = document.createElement('a');
  a.href = fileUrl;
  a.download = fileName;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
